import { Link } from "react-router-dom";
import { categories, kuaibaoList } from "@/mocks/kuaibao";

export default function CategoryGrid() {
  return (
    <section className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="mb-8 md:mb-10">
          <div className="inline-flex items-center gap-2 mb-3">
            <span className="w-6 h-[3px] rounded-full bg-secondary-500"></span>
            <span className="font-label text-xs tracking-[0.2em] text-secondary-700">
              TOPICS
            </span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950">
            只看你关心的那一块
          </h2>
          <p className="font-label text-sm text-foreground-500 mt-2">
            八个内容板块，点进去就是该分类的今日全部快报
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => {
            const count = kuaibaoList.filter((item) => item.categorySlug === cat.slug).length;
            return (
              <Link
                key={cat.slug}
                to={`/kuaibao?cat=${cat.slug}`}
                className="group flex flex-col p-4 md:p-5 rounded-lg border border-background-200/80 bg-background-100 hover:border-primary-300 hover:bg-background-50 transition-colors"
              >
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors">
                  <i className={`${cat.icon} text-xl leading-none`}></i>
                </span>
                <span className="font-heading font-semibold text-foreground-950 text-base md:text-lg mb-1.5">
                  {cat.name}
                </span>
                <span className="font-label text-xs text-foreground-500 leading-relaxed line-clamp-2 flex-1">
                  {cat.desc}
                </span>
                <span className="mt-3 inline-flex items-center gap-1 font-label text-xs text-foreground-400">
                  <i className="ri-file-list-3-line leading-none"></i>
                  本站 {count} 条快报
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}